import { AnnouncementPlatform } from '@tabeeb/contracts/microservices/swagger-article-service'

export const AnnouncementPlatformDisplayName: Record<AnnouncementPlatform, string> = {
  [AnnouncementPlatform.All]: 'All',
  [AnnouncementPlatform.Web]: 'Web',
  [AnnouncementPlatform.Mobile]: 'Mobile',
}

export { AnnouncementPlatform }
